import { PromoCodeRegistrationManagerDictionary } from 'types/i18n';

export const promocodeRegistrationManagerDictionaryRy: PromoCodeRegistrationManagerDictionary = {
  titleText: 'Промокод',
  copiedTooltipText: 'Промокод скопирован',
  passwordInputPlaceholderText: 'Ваш пароль',
  submitPasswordActionText: 'Продолжить',
  submitPromoCodeActionText: 'Новый промокод',
  promoCodeRegistrationFailedText: 'Извините, сервис временно недоступен',
};
